<div>
  <p-header>

  </p-header>
  <div class="variance-modal-links m-2" style="display: flex; align-items: center; gap: 10px; padding-top:5px;">
    <p-button label="Information" styleClass="p-button-rounded p-button-info p-button-sm" (click)="openTab(1)"></p-button>
    <p-button label="Documents" styleClass="p-button-rounded p-button-info p-button-sm" (click)="openTab(2)"></p-button>
    <span class="badge badge-light"> {{ totalCount }} </span>
  </div>
  <div class="row m-2 p-2" *ngIf="documentService.tab===2">
    <app-browse-documents class="row w-100" [record]="selectedRow" (valueChange)='updateDocumentCount($event)'></app-browse-documents>
  </div>
  <div class="row m-2 p-2" *ngIf="documentService.tab===3">
      <app-upload-document [record]="selectedRow" class="col-12" (updateValue)='updateCount($event)'></app-upload-document>
  </div>
  <div class="row m-2 p-2" [hidden]="documentService.tab!==1">
  <div class="col-md-12 text-center my-2">
    <!-- <p-message [(value)]="msgs"></p-message> -->
    <!-- <p-message *ngIf="msg!=''" severity="info" [text]="msg"></p-message> -->
  </div>

    <div class="row" style="width:100%;">
    <div class="col-md-12 text-center my-2">
    <!--   <p-message [(value)]="msgs"></p-message>
      <p-message *ngIf="msg!=''" severity="info" [text]="msg"></p-message> -->
    </div>
    <div class="col-md-6">
      
      <ul class="maap-modal-list">
        <li> <span class="maap-title">PATIENT NAME:</span><span
            class="maap-title-value">{{isDeId(selectedRow?.patientName)}}</span> </li>
        <li> <span class="maap-title">PATIENT ID:</span><span class="maap-title-value">{{selectedRow?.patientId}}</span>
        </li>
        <li> <span class="maap-title">MED DESC:</span><span class="maap-title-value">{{selectedRow?.medDesc}}</span>
        </li>
        <li> <span class="maap-title">SERIAL NUMBER:</span><span
            class="maap-title-value">{{selectedRow?.serialIdentifier}}</span> </li>
        <li> <span class="maap-title">Stock Area:</span><span class="maap-title-value">{{selectedRow?.loc}}</span> </li>
        <li> <span class="maap-title">User ID:</span><span class="maap-title-value">{{isDeId(selectedRow?.adminId)}}</span>
        </li>
        <li> <span class="maap-title">User Name:</span><span
            class="maap-title-value">{{isDeId(selectedRow?.employeeName)}}</span>
        </li>
        <li> <span class="maap-title">Role:</span><span class="maap-title-value">{{selectedRow?.userGrp}} </span>
        </li>
        <li>
          <hr />
        </li>
        <div class="backshadow-container">
          <ng-container *ngIf="['Waste Retrieval','Added Waste Reconcilliation'].includes(selectedRow.source)">
            <li> <span class="maap-title">WASTE AMOUNT EXPECTED:</span><span
                class="maap-title-value">{{selectedRow?.expectedWaste | formatQuantity}}</span> </li>
            <li> <span class="maap-title">WASTE AMOUNT RETRIEVED:</span><span
                class="maap-title-value">{{selectedRow.wasteAmountRecieved | formatQuantity}}</span> </li>
            <li> <span class="maap-title">VAR/QTY:</span><span
                class="maap-title-value">{{selectedRow?.var | formatQuantity}}</span></li>
            <li> <span class="maap-title">UOM:</span><span 
                class="maap-title-value">{{selectedRow?.wasteUOM2}}</span></li>
          </ng-container>
          <ng-container *ngIf="['Assay','Added Waste Assay'].includes(selectedRow.source)">
            <li onload="changingOfPass($event)">
              <span class="maap-title">ASSAY PASS: </span>
              <span *ngIf="selectedRow?._Pass; else no"><b>Yes</b></span>
              <ng-template #no><b>No</b></ng-template>
            </li>   
            <li onload="changingOfFail($event)">
              <span class="maap-title">ASSAY FAIL: </span>
              <span *ngIf="selectedRow?._Fail; else no"><b>Yes</b></span>
              <ng-template #no><b>No</b></ng-template>
            </li>
            <li> <span class="maap-title">HQI FAIL:</span><span
              class="maap-title-value">{{selectedRow?._HQI === true?"Yes":""}}</span> </li>
            <li> <span class="maap-title">HPLC ASSAY:</span><span
                class="maap-title-value">{{selectedRow?._HPLCAssayResults}}</span>
            <li> <span class="maap-title">PENDING HPLC RESULTS:</span><span
                class="maap-title-value">{{selectedRow?._PendingHPLCResults?"Yes":"No"}}</span>
          </ng-container>
          <li> <span class="maap-title"></span>In Source, Out Source Or Commercial:<span
              class="maap-title-value">{{selectedRow?._InSource?"In Source":""}}{{selectedRow?._OutSource?"Out
              Source":""}}{{selectedRow?._Commercial?"Commercial":""}}</span> </li>
          <li> <span class="maap-title">SOURCE:</span><span 
              class="maap-title-value">{{selectedRow?.source}}</span> </li>
          <li> <span class="maap-title">DATE TIME:</span><span
              class="maap-title-value">{{formatDateCustom(selectedRow.varDateString)}}</span> </li>
          <li> <span class="maap-title">Practice Issue:</span><span 
              class="maap-title-value">{{selectedRow?.practiceIssue}}</span></li>
          <li> <span class="maap-title">Comment:</span><span 
              class="maap-title-value">{{selectedRow.comment}}</span></li>
        </div>
        <li>
          <hr />
        </li>
        <li>
          <span class="maap-title">CS WASTE RETRIEVAL STAFF MEMBER:</span><span
            class="maap-title-value">{{selectedRow?.loggedInUserName}}</span>
        </li>
        <li>
          <span class="maap-title">CS WASTE VERIFICATION WITNESS:</span><span
            class="maap-title-value">{{selectedRow?.witnessName}}</span>
        </li>
      </ul>

      <hr>
      <!-- <ul class="maap-modal-list">
              <li> <span class="maap-title">Assay Number :</span><span class="maap-title-value">
                     </span> </li>
              <li><span class="maap-title">Process Date:</span><span class="maap-title-value"> </span> </li>
              <li> <span class="maap-title">Assay Risk Score:</span><span class="maap-title-value"> </span> </li>
          </ul> -->


    </div>
    <div class="col-md-6">
      <div class="row">
        <div class="col-lg-9">
            <div class="form-group">
              <h6 *ngIf="selectedRow.mappAssayRecomended === true" class="text-danger"><b>User Score Recommended</b></h6>
                <h4 class="maap-title-2">Variance Type</h4>
                <div class="form-group  mt-4" style="margin-top:0px !important;margin-bottom:0px;">
                  <label class="form-check-label font-weight-bold mr-2" for="Verified">Verified </label>
                  <p-checkbox [binary]="true" [(ngModel)]="transType" id="Verified"></p-checkbox>
                </div> 
                  <label for="resolution">Variance Status</label>
                    <p-select 
                        [options]="resolutionOptions" 
                        [(ngModel)]="resCoding" 
                        appendTo="body"
                        [filter]="true" 
                        placeholder="Select One"
                        [styleClass]="'change-status-dropdown-sm w-100'">
                        <ng-template let-item pTemplate="selectedItem">
                            <span class="mention-label" style="vertical-align:middle; margin-left: .5em;">{{item.label}}</span>
                        </ng-template>
                        <ng-template let-followup pTemplate="item">
                            <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                                <div style="float:center;margin-top:4px">
                                    {{followup.label}}
                                </div>
                            </div>
                        </ng-template>
                    </p-select>
            </div>     
            <div class="form-group"> 
              <h4 class="maap-title-2">Practice Issue:</h4>
              <p-multiSelect [showToggleAll]="false" name="practiceIssue" [styleClass]="'change-status-practice-issue'" [options]="practiceIssueOptions" [(ngModel)]="pracIssue" filter="true" placeholder="Practice Issue" styleClass="dds" [style]="{'width':'275px'}"></p-multiSelect>
            </div>
        </div>
        <!-- <div class="col-lg-3 pl-0">
            
        </div> -->
    </div>
     <!-- Update the Verified checkbox MV2-425--->
      <div class="form-group">
        <h4 class="maap-title-2">Comment</h4>
        <app-mention-editor [(value)]="comment" [(taggedUsers)]="taggedUsers"
          [users]="userMentions" [minRows]="5"></app-mention-editor>
      </div>

      <h4 class="maap-title-2">History</h4>

      <div class="comment-history" style="height:150px;width:100%;padding:10px;overflow:auto;">
        <div *ngFor="let comment of comments">
          <p>{{comment["createdAt"]| date : 'MM/dd/yyyy | HH:mm'}} - {{comment['resolution']}} </p>
          <p>{{comment["practiceIssue"]}}</p>
          <p>{{comment["comment"]}}</p>
          <p class="font-weight-bold" style="text-align:right">
            <span class="font-weight-light font-italic">By </span><span>{{comment['loggedInUserName']}}</span> <br />
            <span class="font-weight-light font-italic">Witness </span><span>{{comment['witnessName']}}</span>
            <br>
        </div>
      </div>

    </div>
    <div class="col-md-12">
      
      <p class="font-weight-bold float-left">{{lockMessage}}</p> 
      <p-footer>
        <div style="display: flex; justify-content: flex-end; gap: 8px;">
          <p-button label="Cancel" [raised]="true" severity="info" (click)="closeDialog()"></p-button>
          <p-button label="Submit" [raised]="true" severity="info" (click)="submit()" [disabled]="isLocked"></p-button>
          <p-button label="Share" icon="pi pi-share-alt" [raised]="true" severity="info" (click)="shareAdminFollowUp()"></p-button>
        </div>
      </p-footer>
    </div>
  </div>


</div>
